import React from 'react';
import classes from './../Auth.module.scss';
import { BoxNotification } from '../../../components/containers/BoxNotification';
import { Button } from '../../../components/actions/Button';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { Input } from '../../../components/forms/Input';
import { SendPasswordResetEmailMutationVariables } from '../../../models/graphql';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { InputTypes } from '../../../constants/form';
import { SubmitHandler } from 'react-hook-form/dist/types/form';

export type ForgotPasswordViewProps = {
  //
  emailRules: RegisterOptions;
  formInstance: UseFormReturn<SendPasswordResetEmailMutationVariables>;
  loading: boolean;
  requestError: string | JSX.Element;
  onSubmit: SubmitHandler<SendPasswordResetEmailMutationVariables>;
};

export const ForgotPasswordView = (props: ForgotPasswordViewProps): JSX.Element => {
  const errorMessage = props.requestError ? (
    <div className={'margin-bottom-small-32'}>
      <BoxNotification type={'error'}>{props.requestError}</BoxNotification>
    </div>
  ) : null;
  // we need to cast UseFormReturn<T> back to UseFormReturn
  const formInstance: UseFormReturn = props.formInstance as unknown as UseFormReturn;
  return (
    <div className={classes.Title}>
      <div className={'margin-bottom-small-40'}>
        <h2>Reset Your Password</h2>
      </div>
      <div className={'margin-bottom-small-32'}>
        <BoxNotification type={'info'}>
          <p>
            Forgotten or lost your password? Enter your email address to reset your password. If you can no longer
            access that email address, please{' '}
            <a href={'/contact'} target={'_blank'} rel="noreferrer">
              contact us
            </a>
            .
          </p>
        </BoxNotification>
      </div>
      {errorMessage}
      <form className={'grid-x grid-padding-x'} onSubmit={props.formInstance.handleSubmit(props.onSubmit)}>
        <div className={'cell small-12 margin-bottom-small-26'}>
          <Input
            disabled={props.loading}
            formInstance={formInstance}
            name={'email'}
            type={InputTypes.email}
            size={'large'}
            inlinedLabel
            label={'Email'}
            rules={props.emailRules}
          />
        </div>
        <div className={'cell small-12'}>
          <Button
            type={'submit'}
            variant={'solid'}
            size={'large'}
            expanded
            disabled={props.loading}
            color={ButtonColorsEnum.secondary}
            loading={props.loading}>
            Request New Password
          </Button>
        </div>
      </form>
    </div>
  );
};
